import { combineReducers } from 'redux'
import { createPivotTableReducer } from 'reducers/pivotTable'
export const trustedDevicesPivotTableKey = 'settingsContext.trustedDevice.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({key: trustedDevicesPivotTableKey, defaultSortColumn: 'row', defaultSortDirection: 'asc', pageSize: 50}),
})
